'use strict';

var dom           = require('spa-dom'),
    app           = require('mag-app'),
    prepareMovies = require('./prepare.movies'),
    tag           = dom.tag;


/**
 * Change server data to list data.
 *
 * @param {Array} data - data for prepare
 *
 * @return {Array} ready data for LayoutList
 */
module.exports = function ( data ) {
    var result = [],
        $focusWrapper, $blurWrapper,
        count, fill;

    if ( app.metrics.grid.lineCount < data.length ) {
        fill = true;
        count = app.metrics.grid.lineCount;
    } else {
        count = data.length;
    }
    if ( data && data.length ) {
        result = prepareMovies(data.slice(0, count));

        if ( fill ) {
            $focusWrapper = tag(
                'div',
                {className: 'focusWrapper'},

                tag(
                    'div',
                    {className: 'container'},
                    tag('div', {className: 'poster seeMore'})
                ),

                tag('div', {className: 'movieTitle'}, gettext('See more'))
            );

            $blurWrapper = tag(
                'div',
                {className: 'blurWrapper'},
                tag('div', {className: 'poster seeMore'})
            );

            result.push({
                items: [
                    $focusWrapper,
                    $blurWrapper
                ],
                value: false
            });
        }
    }

    return result;
};
